import React from "react";
import StoryCarousel from "../StoryCarousel";

function Video() {
  return (
    <StoryCarousel
      id="home-videos-title"
      eyebrow="Watch"
      title="Videos"
      categories="4"
      viewMoreHref="/stories?page=1&categories=4"
      viewMoreLabel="All videos"
      fallbackLabel="Video"
      ctaLabel="Watch the video"
      perView={{ sm: 2, md: 3, lg: 3 }}
      isVideo
    />
  );
}

export default React.memo(Video);
